import { useState } from 'react';

import { Brand } from '../../generated';

import { useGrowintelService, useParams } from '@growdash/growintel/hooks';
import { useQuery } from '@tanstack/react-query';

import BrandActions from './fragments/brand-actions';
import BrandPageTabs from './fragments/brand-page-tabs';
import BrandBranchesView from './view/brand-branches-view';
import BrandMenuView from './view/brand-menu-view';
import BrandOverviewView from './view/brand-overview-view';

export default function RestaurantDetailPage() {
  const params = useParams();
  const service = useGrowintelService();

  const [activeTab, setActiveTab] = useState<'overview' | 'menu' | 'branches'>(
    'overview',
  );

  const { data, isFetching } = useQuery({
    queryKey: ['brand', params.id],
    queryFn: async (): Promise<Brand | undefined | null> => {
      if (!params.id) return null;
      const response = await service?.brandsAPI.getBrandBrandsIdGet(params.id);
      return response?.data;
    },
  });

  return (
    <>
      <div className="w-full animate-fade-in">
        <BrandActions brand={data} isLoading={isFetching} />
        <BrandPageTabs activeTab={activeTab} onTabChange={setActiveTab} />

        {activeTab === 'overview' && (
          <BrandOverviewView
            setActiveTab={setActiveTab}
            isBrandLoading={isFetching}
            brand={data ?? ({} as Brand)}
          />
        )}
        {activeTab === 'menu' && <BrandMenuView />}
        {activeTab === 'branches' && <BrandBranchesView />}
      </div>
    </>
  );
}
